import { StyledJumper, StyledJumperContent } from './PaginationItemJumper.styles';

const PaginationItemJumper = () => (
  <li aria-hidden>
    <StyledJumper>
      <StyledJumperContent>&#x25CF;</StyledJumperContent>
    </StyledJumper>
  </li>
);

export default PaginationItemJumper;
